let id = null;

const scrollHandler = (e) => {
  const st = window.pageYOffset || document.documentElement.scrollTop;
  const buttons = document.querySelectorAll("button");
  [...buttons].forEach(
    (b, i) =>
      (b.style.transform = `rotate(${
        ((Math.random() * st) / 3) * (i % 2 ? 1 : -1)
      }deg)`)
  );
};

const cleanup = (canvas) => {
  cancelAnimationFrame(id);
  document.removeEventListener("scroll", scrollHandler);
  const buttons = document.querySelectorAll("button");
  [...buttons].forEach((b, i) => (b.style.transform = `none`));
  canvas.remove();
};

const init = () => {
  (function () {
    var requestAnimationFrame =
      window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        window.setTimeout(callback, 1000 / 60);
      };
    window.requestAnimationFrame = requestAnimationFrame;
  })();

  const flakes = [];
  const canvas = document.querySelector(".canvas");
  const ctx = canvas.getContext("2d");
  let flakeCount = 500;
  let mX = -100;
  let mY = -100;

  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;

  function snow() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    for (var i = 0; i < flakeCount; i++) {
      var flake = flakes[i],
        x = mX,
        y = mY,
        minDist = 450,
        x2 = flake.x,
        y2 = flake.y;

      var dist = Math.sqrt((x2 - x) * (x2 - x) + (y2 - y) * (y2 - y)),
        dx = x2 - x,
        dy = y2 - y;

      if (dist < minDist) {
        var force = minDist / (dist * dist),
          xcomp = (x - x2) / dist,
          ycomp = (y - y2) / dist,
          deltaV = force / 2;

        flake.velX -= deltaV * xcomp;
        flake.velY -= deltaV * ycomp;
      } else {
        flake.velX *= 0.98;
        if (flake.velY <= flake.speed) {
          flake.velY = flake.speed;
        }
        flake.velX += Math.cos((flake.step += 0.05)) * flake.stepSize;
      }

      ctx.fillStyle = "#" + (((1 << 24) * Math.random()) | 0).toString(16);
      flake.y += flake.velY;
      flake.x += flake.velX;

      if (flake.y >= canvas.height || flake.y <= 0) {
        reset(flake);
      }

      if (flake.x >= canvas.width || flake.x <= 0) {
        reset(flake);
      }

      ctx.beginPath();
      ctx.arc(flake.x, flake.y, flake.size, 0, Math.PI * 2);
      ctx.fill();
    }
    id = requestAnimationFrame(snow);
  }

  function reset(flake) {
    flake.x = Math.floor(Math.random() * canvas.width);
    flake.y = 0;
    flake.size = Math.random() * 3 + 2;
    flake.speed = Math.random() * 3 + 1;
    flake.velY = flake.speed;
    flake.velX = 0;
    flake.opacity = Math.random() * 0.5 + 0.3;
  }

  function init() {
    for (var i = 0; i < flakeCount; i++) {
      var x = Math.floor(Math.random() * canvas.width),
        y = Math.floor(Math.random() * canvas.height),
        size = Math.random() * 3 + 2,
        speed = Math.random() * 2 + 0.75,
        opacity = Math.random() * 0.5 + 0.3;

      flakes.push({
        speed: speed,
        velY: speed,
        velX: speed,
        x: x,
        y: y,
        size: size,
        stepSize: Math.random() / 30,
        step: 0,
        opacity: opacity,
      });
    }

    snow();
  }

  canvas.addEventListener("mousemove", function (e) {
    (mX = e.clientX), (mY = e.clientY);
  });

  document.addEventListener("scroll", scrollHandler);

  init();
};

const show = (clean) => {
  const parent = document.querySelector("div.mt-3.col-md-12.col-lg-6.col-xl-6");
  const top = parent.querySelector(".row");
  const [left, right] = [...top.children];
  const imgCount = document.querySelectorAll(
    `img[src='${process.env.PUBLIC_URL}/logo.png']`
  ).length;
  if (!clean) {
    const image = document.createElement("img");
    const cmn = {
      transition: "1s",
      zIndex: "-1",
    };
    const leftStyles = {
      ...cmn,
      transform: "translate(-120%, 80%)",
    };
    const rightStyles = {
      ...cmn,
      transform: "translate(120%, -80%)",
    };
    const imageStyles = {
      position: "absolute",
      top: `${((imgCount + 1) / 2) * 25}%`,
      left: imgCount % 2 ? "60%" : "20%",
      right: "0",
      transform: "scale(0)",
    };
    Object.entries(leftStyles).forEach(([k, v]) => (left.style[k] = v));
    Object.entries(rightStyles).forEach(([k, v]) => (right.style[k] = v));
    image.setAttribute("src", `${process.env.PUBLIC_URL}/logo.png`);
    Object.entries(imageStyles).forEach(([k, v]) => (image.style[k] = v));
    top.appendChild(image);
    image.classList.add("blink");
    window.setTimeout(() => {
      image.animate(
        [
          { transform: "scale(0)" },
          { transform: "scale(1.2)" },
          { transform: "scale(1.4)" },
          { transform: "scale(1.6)" },
          { transform: "scale(1.8)" },
          { transform: "scale(2.1)" },
          { transform: "scale(2)" },
          { transform: "scale(1.9)" },
          { transform: "scale(2)" },
          { transform: "scale(2.05)" },
          { transform: "scale(1.95)" },
          { transform: "scale(2)" },
        ],
        {
          duration: 1000,
          iterations: 1,
        }
      );
    }, 500);
  } else {
    const cleanStyles = {
      transition: "unset",
      zIndex: "unset",
      transform: "none",
    };
    Object.entries(cleanStyles).forEach(([k, v]) => {
      left.style[k] = v;
      right.style[k] = v;
    });
    [
      ...document.querySelectorAll(
        `img[src='${process.env.PUBLIC_URL}/logo.png']`
      ),
    ].forEach((e) => e.remove());
  }
};

export { cleanup, init, show };



// WEBPACK FOOTER //
// ./src/helpers/script.js